module.exports = __webpack_public_path__ + "static/media/status-ko.fbced74c.svg";